document.addEventListener('DOMContentLoaded', () => {
		const demandFormParent = document.querySelector('.modal__form');
		const demandForm = document.querySelectorAll('.modal__form form');
		if (demandForm) {
				demandForm.forEach((el) => {
						const fv = FormValidation.formValidation(el, {
								locale: 'sl_SI',
								localization: FormValidation.locales.sl_SI,
								fields: {},
								plugins: {
										message: new FormValidation.plugins.Message({
												container: (field, element) => element.closest('.mod-input,.checkbox'),
										}),
										declarative: new FormValidation.plugins.Declarative({
												html5Input: true,
										}),
										trigger: new FormValidation.plugins.Trigger(),
										submitButton: new FormValidation.plugins.SubmitButton(),
								},
						}).on('core.form.valid', () => {
								const formData = {};
								el.querySelectorAll('input, textarea, hidden').forEach((input) => {
										if (input.type === 'checkbox') {
												formData[input.name] = input.checked;
										} else {
												formData[input.name] = input.value.trim();
										}
								});
								grecaptcha.ready(() => {
										grecaptcha.execute(localData.captchaSiteKey, { action: formData.action }).then((token) => {
												const formDataImage = new FormData();
												if (formData.action === 'sleepingProfileEmail') {
														formDataImage.append('url', window.location.href);
												}
												formDataImage.append('action', formData.action);
												formDataImage.append('nonce', formData.nonce);
												formDataImage.append('inputs', JSON.stringify(formData));
												formDataImage.append('lang', localData.lang);
												formDataImage.append('id', localData.id);
												formDataImage.append('token', token);
												axios
														.post(localData.siteURL, formDataImage, {
																headers: {
																		'Content-Type': 'multipart/form-data',
																},
														})
														.then((response) => {
																if (response.status === 200 && response.data.data.url) {
																		window.location = response.data.data.url;
																} else if (response.status === 200 && response.data.data.message) {
                                    const outOfStockModal = document.querySelector('.out-of-stock-modal');
                                    if (outOfStockModal) {
                                      outOfStockModal.querySelector('.modal__body .editor-text').remove();
                                      outOfStockModal.querySelector('.modal__body .margin').remove();
                                    }
																		// eslint-disable-next-line no-param-reassign
																		el.innerHTML = `<div>${response.data.data.message}</div>`;
																		el.scrollIntoView({ behavior: 'smooth', block: 'center' });
																}
														})
														.catch((error) => {
																console.error(error);
														});
										});
								});
						});
				});
		}
});
